exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.title-uso-do-solo[data-v-2b49957b]{font-size:16px;font-weight:600;color:#454646\n}\n", "", {"version":3,"sources":["/app/src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/UsoDoSolo/style.scss"],"names":[],"mappings":";AAAA,oCACE,eACA,gBACA,aAAc;CACf","file":"UsoDoSolo.vue","sourcesContent":[".title-uso-do-solo {\n  font-size: 16px;\n  font-weight: 600;\n  color: #454646;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b49957b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/UsoDoSolo/UsoDoSolo.vue
// module id = bFxv
// module chunks = 5